import { getPropertyValueOrDefault } from '../../../../../utils/generalUtilities';

const get = state => state.competitiveMedia;

export const getCompetitiveMediaDataSelector = state => get(state);

export const getCompetitiveMediaSectionsSelector = state => {
    return getPropertyValueOrDefault(get(state), 'sections', null);
};
